import { Component, OnInit, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../_services';
import { VendorService } from 'src/app/_services/vendor.services';
import { Subscription } from 'rxjs';
import { DashboardRefreshService } from 'src/app/_services/dashboard-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { brandName } from 'src/app/theme/brand.name.enum';
import { BffAuthService } from 'src/app/_services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { NotificationService } from 'src/app/_services/notification.service.v2';

@Component({
  selector: 'telio-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  refreshNeeded = false;
  notifierSubscription: Subscription = this.refreshService.subjectNotifier.subscribe(notified => {
    this.refreshNeeded = true
    this.ngOnInit();
  });
  id: string = "";
  @Input() User;
  currentUser = {};
  userDetails: any = {}
  postData: any = {}
  vendorArray = [];
  vendId: string;
  count: any;
  notificationCount: any;
  userInfoResponse: any;
  adminrole: any;
  userName;
  loginScreenDetails: any;
  isPoweredBy = false;
  copyright = 2023;
  copyrightValue;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private vendorservice: VendorService,
    private refreshService: DashboardRefreshService,
    public translate: TranslateService,
    private notificationService:NotificationService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    readonly title: Title,
    readonly buffAuth: BffAuthService,
    readonly userInfoService: UserInfoService) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    this.userDetails = this.userInfoService.userDetails;
    this.toggleBranding(this.userDetails);
    this.setLoginScreenDetails(this.userDetails);
    this.userDetails.mapIconUrlGray ? this.authenticationService.setMapIconGray(this.userDetails.mapIconUrlGray) : this.authenticationService.setMapIconGray('mapiconexternalstation.png');
    this.userDetails.mapIconUrlGreen ? this.authenticationService.setMapIconGreen(this.userDetails.mapIconUrlGreen) : this.authenticationService.setMapIconGreen('telioevmapsiconnew.png')
    if (this.userDetails) {
      if (this.userDetails.passwordChaned == 'false') {
        this.router.navigate(['/dashboard/home']);
      }
      if (this.userDetails.passwordChaned == 'true') {
        this.router.navigate(['/dashboard/home']);
      }
    }
    this.authenticationService.setEmail(this.userDetails.email);
    this.userName = this.userDetails.userId
    this.getInformationnotificationcount();
    this.getNotificationcount();
    this.vendorArray.push(this.id)
    this.adminrole = this.userInfoService.isAdminGroup() ;

    this.postData = {
      user: this.userDetails.email,
      starting_date: "2021-08-01",
      ending_date: "2021-08-31"
    }
  }

  getUrl() {
    return '';
  }

  get isAdmin() {
    return this.userInfoService.groups && this.userInfoService.isAdminGroup() ;
  }

  getNotificationcount() {
    var temp = this.authenticationService.getEmail();
    this.notificationService.getNotificationcount(temp).subscribe(
      (data) => {
        this.count = data;
      });
  }

  getInformationnotificationcount() {
    this.notificationService.getInfoNotificationCount(this.userName).subscribe(
      (data) => {
        this.notificationCount = data;
      }
    )
  }

  toggleBranding(data) {
    if (!!data && !!data.tenantID) {
      if (data.tenantID.toLowerCase() !== brandName.telioev) {
        this.setRootStyle(data);
        this._document.getElementById('appFavicon').setAttribute('href', data.faviconUrl);
        const changePwdLogo = this._document.getElementById('appLogoChangePassword');
        if (changePwdLogo) {
          changePwdLogo.setAttribute('src', data.logoUrl);
        }
        const carLogo = this._document.getElementById('appCarLogoChangePassword');
        if (carLogo) {
          carLogo.setAttribute('src', data.infoUpdateImageUrl ? data.infoUpdateImageUrl : data.logoUrl);
        }
        this.title.setTitle(data.appTitle);
      } else {
        this.setDefaultTheme(data);
      }
    } else {
      this.setDefaultTheme(data);
    }
  }

  setDefaultTheme(data) {
    this._document.getElementById('appFavicon').setAttribute('href', 'assets/images/telioEv/telioevfavicon.png');
    this.title.setTitle(data.appTitle);
    this.setRootStyle(data);
  }

  setRootStyle(data) {
    let root = document.documentElement;
    root.style.setProperty('--primaryButtonBg', data.primaryButtonBg ? data.primaryButtonBg : "#206BB7");
    root.style.setProperty('--secondaryButtonBg', data.secondaryButtonBg ? data.secondaryButtonBg : "#3BB96C");
    root.style.setProperty('--thirdButtonBg', data.thirdButtonBg ? data.thirdButtonBg : "#A8A8A8");
    root.style.setProperty('--mainColor', data.mainColor ? data.mainColor : "#206BB7");
  }

  setLoginScreenDetails(data) {
    this.isPoweredBy = data.tenantType === 2;
    this.copyright = data.tenantType === 1 ? 2023 : 2023;
    this.loginScreenDetails = data.tenantType !== 0 ? data : { 'appTitle': environment.branding.title };
    this.copyrightValue = localStorage.getItem('copyright')
  }
}
